import * as Sentry from '@sentry/react'
import axios from 'axios'

import { handleRequestError } from './request'

export const SEND_MAGIC_LINK = 'SEND_MAGIC_LINK'
export const RESOLVE_MAGIC_LINK = 'RESOLVE_MAGIC_LINK'

export const sendMagicLink = (data) => (dispatch) => {
    dispatch({ type: SEND_MAGIC_LINK, data })

    const { phoneNumber, url } = data

    return axios.post('/magiclinks', { phoneNumber, url }).catch((error) => {
        dispatch(
            handleRequestError(error, {
                hideAlert: true,
                customMessage: 'Por favor, verifique el número de teléfono o vuelva intentarlo más tarde',
            })
        )
        return Promise.reject(error)
    })
}

export const resolveMagicLink = (data) => (dispatch) => {
    dispatch({ type: RESOLVE_MAGIC_LINK, data })

    const { identifier } = data

    return axios
        .get(`/magiclinks/${identifier}`)
        .then((response) => {
            const { accessToken, url } = response?.data || {}

            if (!accessToken || !url) {
                Sentry.withScope((scope) => {
                    scope.setExtra('action', 'resolveMagicLink')
                    scope.setExtra('identifier', identifier)
                    scope.setExtra('response', response)
                    Sentry.captureException(new Error("Couldn't find 'accessToken' and/or 'url' in the response"))
                })

                return Promise.reject()
            }

            return Promise.resolve({ accessToken, url })
        })
        .catch((error) => {
            Sentry.withScope((scope) => {
                scope.setExtra('action', 'resolveMagicLink')
                Sentry.captureException(error)
            })

            return Promise.reject()
        })
}
